<template>
  <div class="layout layout--simple">
    <SimpleNav></SimpleNav>
    <FlashMessages class="layout__flash" />
    <NoticeMessage />
    <div class="layout__container">
      <div class="layout__content">
        <slot></slot>
      </div>
      <SimpleFooter :customerServiceData="customerServiceData"></SimpleFooter>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { onLoad } from '@/helpers/event'
import FlashMessages from '@/components/_shared/FlashMessage/FlashMessages.vue'
import NoticeMessage from '@/components/_shared/NoticeMessage/NoticeMessage.vue'
import SimpleNav from '@/components/Navigation/SimpleNav/SimpleNav.vue'
import SimpleFooter from '@/components/Footer/SimpleFooter/SimpleFooter.vue'

export default {
  name: 'SimpleLayout',

  components: {
    FlashMessages,
    NoticeMessage,
    SimpleNav,
    SimpleFooter,
  },

  mounted() {
    onLoad().then(this.fetchData)
  },

  computed: {
    ...mapGetters({
      customerServiceEmail: 'store/customerServiceEmail',
      customerServicePhone: 'store/customerServicePhone',
    }),

    customerServiceData() {
      return {
        email: this.customerServiceEmail,
        phone: this.customerServicePhone,
      }
    },
  },

  methods: {
    fetchData() {
      this.$store.dispatch('store/fetchData')
    },
  },
}
</script>

<style scoped lang="scss">
.layout {
  &__container {
    max-width: $mq-width-full;
    margin: space(8) auto space(12);
    padding: 0 $site-gutter;

    @media ($mq-large) {
      padding: 0 $site-gutter-xlarge;
    }

    @media ($mq-larger) {
      padding: 0 45px;
    }
  }

  &__flash {
    top: 0;
  }

  &__content {
    @media ($mq-large) {
      margin-bottom: space(16);
    }
  }
}
</style>